import { Modal } from "antd";

const DeleteConfirmation = ({
  isVisible,
  onConfirm,
  onCancel,
  title,
  content,
  okText,
  confirmLoading,
}) => {
  return (
    <Modal
      title={title || "Confirm Deletion"}
      open={isVisible}
      onOk={onConfirm}
      onCancel={onCancel}
      className="vm__modal vm__modal-sm"
      okText={okText || "Delete"}
      cancelText="Cancel"
      confirmLoading={confirmLoading}
      maskClosable={false}
    >
      <p>
        {content ||
          "Are you sure you want to delete this item? This action cannot be undone."}
      </p>
    </Modal>
  );
};

export default DeleteConfirmation;
